'use client';

import type {MobileSubMenuListProps as Props} from './typings';

import SideMenuList from './SideMenuList';
import {StyledSideMenuListItem} from './styles';

const MobileSubMenuList = ({submenu, handleItemClick, isActive}: Props): JSX.Element => {
  const {title, links, highlights} = submenu;

  return (
    <SideMenuList heading={title} aria-label={`Sub-menu list${title ? ` for ${title}` : ''}`}>
      {links.map(({link, text, component}) => {
        return (
          <StyledSideMenuListItem key={`${text}${link}`} $isSubMenu aria-label={text}>
            <a href={link as string} onClick={handleItemClick} tabIndex={isActive ? 0 : -1}>
              {text || component}
            </a>
          </StyledSideMenuListItem>
        );
      })}

      {highlights?.length &&
        highlights.map(({text, component, link}) => {
          return (
            <StyledSideMenuListItem
              key={`highlight-${text}${link}`}
              $isSubMenu
              aria-label={`Highlight item: ${text}`}
            >
              <a href={link as string} onClick={handleItemClick} tabIndex={isActive ? 0 : -1}>
                {text || component}
              </a>
            </StyledSideMenuListItem>
          );
        })}
    </SideMenuList>
  );
};

export default MobileSubMenuList;
